import * as React from 'react';
import classNames from 'classnames';
import { Switch, Route } from "react-router-dom";

/**
 * Componentes del sistema.
 */
import AppTopBar from '../../Components/Layout/AppTopBar';
import AppMenu from '../../Components/Layout/AppMenu';
import InfoDashboard from './InfoDashboard';
import { ROLES, ROUTES } from '../../Utils/constants';
import Transportistas from '../Catalogos/Transportistas';
import Concesionarios from '../Catalogos/Concesionarios';
import ViajesEnCurso from '../Consultas/ViajesEnCurso';
import ViajesEntregados from '../Consultas/ViajesEntregados';
import AdministradorSistema from '../Usuarios/AdministradorSistema';
import AdministradorDealer from '../Usuarios/AdministradorDealer';
import { getUsuarioLogueado } from '../../Utils/gestionSessionStorage';
import Inspector from '../Usuarios/Inspector';
import AdminTransportista from '../Usuarios/AdminTransportista';
import Conductor from '../Usuarios/Conductor';
import Viajes from '../Consultas/Viajes';
import Bitacora from '../Consultas/Bitacora';
import Emergencia from '../Rev/Emergencia';
import logo from '../../Themes/assets/images/logo-vwm.png';
import NuevoCodigo from '../Consultas/NuevoCodigo';
import UsoApp from '../Consultas/UsoApp';
import Correos from '../Usuarios/Correos';
import TipoDanio from '../Catalogos/TipoDanio';
import AreaDanio from '../Catalogos/AreaDanio';
import SeveridadDanio from '../Catalogos/SeveridadDanio';

/**
 * Definir las propiedades que recibe el componente.
 */
interface Props {
}

/**
 * Definir el estado del componente.
 */
interface State {
    layoutMode: string;
    layoutColorMode: string;
    overlayMenuActive: boolean;
    staticMenuInactive: boolean;
    mobileMenuActive: boolean;
    usuario:{}|undefined;
    rol:string;
    tipo:string;
}

/**
 * @class
 * Componente que permite estructurar todos
 * los componentes del sistema.
 */
class DashboardContainer extends React.Component<Props, State> {
    menu: object[];
    menuClick: boolean;

    /**
     * @constructor
     * Inicializar el estado del componente.
     * @param {any} props Propiedades generadas
     */
    constructor(props: any) {
        super(props);
        this.menu = [];
        this.menuClick = false;
        this.state = {
            usuario:{},
            layoutMode: 'static',
            layoutColorMode: 'light',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            tipo:'',
            rol:''
        };
        this.onToggleMenu = this.onToggleMenu.bind(this);
        this.onSidebarClick = this.onSidebarClick.bind(this);
        this.onMenuItemClick = this.onMenuItemClick.bind(this);
        this.createMenu();
    }
    componentDidMount(): void {
        console.log('entra');
        let user = getUsuarioLogueado();
        this.setState({
        usuario: user,
        rol: user !== undefined ? user.rol : '',
        tipo: user !== undefined ? (user.tipoadmin !== undefined ? user.tipoadmin : '') : '',
        });
    }
    /**
     * Asignar las opciones del menú dependiendo del
     * usuario logueado.
     */
    createMenu() {
        var user = getUsuarioLogueado();
        if (user !== undefined && user !== null){
            console.log("logueado", getUsuarioLogueado());
            if (user?.rol === ROLES.ADMINSIS){
                var accesos = user?.rutasAcceso!;
                var nuevosaccesos = [];
                 if (user?.rutasAcceso !== undefined) {
                   nuevosaccesos.push(accesos[0]);
                   nuevosaccesos.push(accesos[1]);
                   nuevosaccesos.push(accesos[2]);
                   nuevosaccesos.push(accesos[3]);
                 }
                var accesos2 = accesos[2] as any;
                var nuevosaccesos2 = nuevosaccesos[2] as any;
               
                if (user?.tipoadmin === "NSO"){
                  //NSO
                  let filteredArray = nuevosaccesos2.items.filter((item: any) => item.label !== 'Transportista');
                  accesos2.items = filteredArray;
                  console.log('menus', accesos);
                  this.menu = accesos;
                }
                else if (user?.tipoadmin === "LOGISTICA"){ //TRANSPORTISTA
                    let filteredArray = nuevosaccesos2.items.filter((item: any) => item.label !== 'Concesionaria');
                    nuevosaccesos2.items = filteredArray;
                    console.log('menus', nuevosaccesos);
                    this.menu = nuevosaccesos;
                }
                else { //GENERAL
                    this.menu = nuevosaccesos;
                }
            } else
            {
                this.menu = user?.rutasAcceso!;
            }
        }
    }

    /**
     * Validar en que dispositivo se visualiza el sistema.
     */
    isDesktop() {
        return window.innerWidth > 1024;
    }

    /**
     * Definir el comportamiento del menú de acuerdo a la
     * resolución de la pantalla donde se visualiza el sistema.
     * @param {any} event Evento cuando se selecciona el menú.
     */
    onToggleMenu(event: any) {
        this.menuClick = true;
        if (this.isDesktop()) {
            if (this.state.layoutMode === 'overlay') {
                this.setState({
                    overlayMenuActive: !this.state.overlayMenuActive
                });
            }
            else if (this.state.layoutMode === 'static') {
                this.setState({
                    staticMenuInactive: !this.state.staticMenuInactive
                });
            }
        }
        else {
            const mobileMenuActive = this.state.mobileMenuActive;
            this.setState({
                mobileMenuActive: !mobileMenuActive
            });
        }
        event.preventDefault();
    }

    /**
     * Asignar el valor de la propiedad menuClick cuando se selecciona
     * el icono de barras en el menú superior del sistema.
     * @param {any} event Evento click del icono.
     */
    onSidebarClick(event: any) {
        this.menuClick = true;
    }

    /**
     * Definir acción cuando se selecciona una opción del menú.
     * @param {any} event Evento click de la opción seleccionada.
     */
    onMenuItemClick(event: any) {
        if(!event.item.items) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            })
        }
    }

    /**
     * @function
     * Función principal para renderizar el contenido del componente.
     */
    render() {
            const Page403 = () => {
              return (
                <div className="p-grid p-fluid p-align-center">
                  <div className="p-col-4"></div>
                  <div className="p-col-4">
                    <h1>Error 403</h1>
                  </div>
                  <div className="p-col-4"></div>
                </div>
              );
            };
        const wrapperClass = classNames('layout-wrapper', {
            'layout-overlay': this.state.layoutMode === 'overlay',
            'layout-static': this.state.layoutMode === 'static',
            'layout-static-sidebar-inactive': this.state.staticMenuInactive && this.state.layoutMode === 'static',
            'layout-overlay-sidebar-active': this.state.overlayMenuActive && this.state.layoutMode === 'overlay',
            'layout-mobile-sidebar-active': this.state.mobileMenuActive
        });

        const sidebarClassName = classNames("layout-sidebar", {
            'layout-sidebar-dark': this.state.layoutColorMode === 'dark',
            'layout-sidebar-light': this.state.layoutColorMode === 'light'
        });
        switch (this.state.rol) {
          case ROLES.CONDUCTOR:
            return (
              <div className={wrapperClass}>
                <AppTopBar onToggleMenu={this.onToggleMenu} />
                <div className={sidebarClassName} onClick={this.onSidebarClick}>
                  <div className="layout-logo">
                    <img alt="VWM" src={logo} />
                  </div>
                  <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                  <div>
                    <p>Build: {process.env.REACT_APP_VERSION}</p>
                  </div>
                </div>
                <div className="layout-main">
                  {/* definir esta rutas igual en el archivo Routes.tsx */}
                  <Switch>
                    <Route path={ROUTES.DASHBOARD} component={InfoDashboard} />
                    <Route path={ROUTES.REV_EMERGENCIA} component={Emergencia} />
                    <Route component={Page403} />
                  </Switch>
                </div>
                {/* <AppFooter /> */}
                <div className="layout-mask"></div>
              </div>
            );
          case ROLES.INSPECTOR:
            return (
              <div className={wrapperClass}>
                <AppTopBar onToggleMenu={this.onToggleMenu} />
                <div className={sidebarClassName} onClick={this.onSidebarClick}>
                  <div className="layout-logo">
                    <img alt="VWM" src={logo} />
                  </div>
                  <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                  <div>
                    <p>Build: {process.env.REACT_APP_VERSION}</p>{' '}
                  </div>
                </div>
                <div className="layout-main">
                  {/* definir esta rutas igual en el archivo Routes.tsx */}
                  <Switch>
                    <Route path={ROUTES.DASHBOARD} component={InfoDashboard} />
                    <Route path={ROUTES.VIAJES} component={Viajes} />
                    <Route path={ROUTES.BITACORA} component={Bitacora} />
                    <Route path={ROUTES.REV_EMERGENCIA} component={Emergencia} />
                    <Route component={Page403} />
                  </Switch>
                </div>
                {/* <AppFooter /> */}
                <div className="layout-mask"></div>
              </div>
            );
          case ROLES.ADMINDEALER:
            return (
              <div className={wrapperClass}>
                <AppTopBar onToggleMenu={this.onToggleMenu} />
                <div className={sidebarClassName} onClick={this.onSidebarClick}>
                  <div className="layout-logo">
                    <img alt="VWM" src={logo} />
                  </div>
                  <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                  <div>
                    <p>Build: {process.env.REACT_APP_VERSION}</p>{' '}
                  </div>
                </div>
                <div className="layout-main">
                  {/* definir esta rutas igual en el archivo Routes.tsx */}
                  <Switch>
                    <Route path={ROUTES.DASHBOARD} component={InfoDashboard} />
                    <Route path={ROUTES.VIAJES} component={Viajes} />
                    <Route path={ROUTES.BITACORA} component={Bitacora} />
                    <Route path={ROUTES.REV_EMERGENCIA} component={Emergencia} />
                    <Route path={ROUTES.USO_APP} component={UsoApp} />
                    <Route path={ROUTES.USUARIOS_INSPECTOR} component={Inspector} />
                    <Route path={ROUTES.NUEVOCODIGO} component={NuevoCodigo} />
                    <Route path={ROUTES.CORREOS} component={Correos} />
                    <Route component={Page403} />
                  </Switch>
                </div>
                {/* <AppFooter /> */}
                <div className="layout-mask"></div>
              </div>
            );
          case ROLES.ADMINTRANSPORTISTA:
            return (
              <div className={wrapperClass}>
                <AppTopBar onToggleMenu={this.onToggleMenu} />
                <div className={sidebarClassName} onClick={this.onSidebarClick}>
                  <div className="layout-logo">
                    <img alt="VWM" src={logo} />
                  </div>
                  <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                  <div>
                    <p>Build: {process.env.REACT_APP_VERSION}</p>{' '}
                  </div>
                </div>
                <div className="layout-main">
                  {/* definir esta rutas igual en el archivo Routes.tsx */}
                  <Switch>
                    <Route path={ROUTES.DASHBOARD} component={InfoDashboard} />
                    <Route path={ROUTES.VIAJES} component={Viajes} />
                    <Route path={ROUTES.BITACORA} component={Bitacora} />
                    <Route path={ROUTES.REV_EMERGENCIA} component={Emergencia} />
                    <Route path={ROUTES.USO_APP} component={UsoApp} />
                    <Route path={ROUTES.USUARIOS_CONDUCTOR} component={Conductor} />
                    <Route component={Page403} />
                  </Switch>
                </div>
                {/* <AppFooter /> */}
                <div className="layout-mask"></div>
              </div>
            );
          case ROLES.ADMINSIS:
            if (this.state.tipo === 'NSO') {
              return (
                <div className={wrapperClass}>
                  <AppTopBar onToggleMenu={this.onToggleMenu} />
                  <div className={sidebarClassName} onClick={this.onSidebarClick}>
                    <div className="layout-logo">
                      <img alt="VWM" src={logo} />
                    </div>
                    <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                    <div>
                      <p>Build: {process.env.REACT_APP_VERSION}</p>{' '}
                    </div>
                  </div>
                  <div className="layout-main">
                    {/* definir esta rutas igual en el archivo Routes.tsx */}
                    <Switch>
                      <Route path={ROUTES.DASHBOARD} component={InfoDashboard} />
                      <Route path={ROUTES.VIAJES} component={Viajes} />
                      <Route path={ROUTES.BITACORA} component={Bitacora} />
                      <Route path={ROUTES.REV_EMERGENCIA} component={Emergencia} />
                      <Route path={ROUTES.USO_APP} component={UsoApp} />
                      <Route path={ROUTES.USUARIOS_ADMINDEALER} component={AdministradorDealer} />
                      <Route path={ROUTES.TIPO_DANIOS} component={TipoDanio} />
                      <Route path={ROUTES.TIPO_AREA} component={AreaDanio} />
                      <Route path={ROUTES.TIPO_SEVERIDAD} component={SeveridadDanio} />
                      <Route component={Page403} />
                    </Switch>
                  </div>
                  {/* <AppFooter /> */}
                  <div className="layout-mask"></div>
                </div>
              );
            } else if (this.state.tipo === 'LOGISTICA') {
              return (
                <div className={wrapperClass}>
                  <AppTopBar onToggleMenu={this.onToggleMenu} />
                  <div className={sidebarClassName} onClick={this.onSidebarClick}>
                    <div className="layout-logo">
                      <img alt="VWM" src={logo} />
                    </div>
                    <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                    <div>
                      <p>Build: {process.env.REACT_APP_VERSION}</p>{' '}
                    </div>
                  </div>
                  <div className="layout-main">
                    {/* definir esta rutas igual en el archivo Routes.tsx */}
                    <Switch>
                      <Route path={ROUTES.DASHBOARD} component={InfoDashboard} />
                      <Route path={ROUTES.VIAJES} component={Viajes} />
                      <Route path={ROUTES.BITACORA} component={Bitacora} />
                      <Route path={ROUTES.REV_EMERGENCIA} component={Emergencia} />
                      <Route path={ROUTES.USO_APP} component={UsoApp} />
                      <Route path={ROUTES.USUARIOS_ADMINTRANS} component={AdminTransportista} />
                      <Route path={ROUTES.TIPO_DANIOS} component={TipoDanio} />

                      <Route component={Page403} />
                    </Switch>
                  </div>
                  {/* <AppFooter /> */}
                  <div className="layout-mask"></div>
                </div>
              );
            } else {
              return (
                <div className={wrapperClass}>
                  <AppTopBar onToggleMenu={this.onToggleMenu} />
                  <div className={sidebarClassName} onClick={this.onSidebarClick}>
                    <div className="layout-logo">
                      <img alt="VWM" src={logo} />
                    </div>
                    <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                    <div>
                      <p>Build: {process.env.REACT_APP_VERSION}</p>{' '}
                    </div>
                  </div>
                  <div className="layout-main">
                    {/* definir esta rutas igual en el archivo Routes.tsx */}
                    <Switch>
                      <Route path={ROUTES.DASHBOARD} component={InfoDashboard} />
                      <Route path={ROUTES.VIAJES} component={Viajes} />
                      <Route path={ROUTES.BITACORA} component={Bitacora} />
                      <Route path={ROUTES.REV_EMERGENCIA} component={Emergencia} />
                      <Route path={ROUTES.USO_APP} component={UsoApp} />
                      <Route path={ROUTES.USUARIOS_ADMINTRANS} component={AdminTransportista} />
                      <Route path={ROUTES.USUARIOS_ADMINDEALER} component={AdministradorDealer} />
                      <Route component={Page403} />
                    </Switch>
                  </div>
                  {/* <AppFooter /> */}
                  <div className="layout-mask"></div>
                </div>
              );
            }
          case ROLES.ADMINUMS:
            return (
              <div className={wrapperClass}>
                <AppTopBar onToggleMenu={this.onToggleMenu} />
                <div className={sidebarClassName} onClick={this.onSidebarClick}>
                  <div className="layout-logo">
                    <img alt="VWM" src={logo} />
                  </div>
                  <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                  <div>
                    <p>Build: {process.env.REACT_APP_VERSION}</p>{' '}
                  </div>
                </div>
                <div className="layout-main">
                  {/* definir esta rutas igual en el archivo Routes.tsx */}
                  <Switch>
                    <Route path={ROUTES.DASHBOARD} component={InfoDashboard} />
                    <Route path={ROUTES.BITACORA} component={Bitacora} />
                    <Route path={ROUTES.USUARIOS_ADMINSIS} component={AdministradorSistema} />
                    <Route component={Page403} />
                  </Switch>
                </div>
                {/* <AppFooter /> */}
                <div className="layout-mask"></div>
              </div>
            );
          case ROLES.ADMINREAD:
            return (
              <div className={wrapperClass}>
                <AppTopBar onToggleMenu={this.onToggleMenu} />
                <div className={sidebarClassName} onClick={this.onSidebarClick}>
                  <div className="layout-logo">
                    <img alt="VWM" src={logo} />
                  </div>
                  <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                  <div>
                    <p>Build: {process.env.REACT_APP_VERSION}</p>{' '}
                  </div>
                </div>
                <div className="layout-main">
                  {/* definir esta rutas igual en el archivo Routes.tsx */}
                  <Switch>
                    <Route path={ROUTES.DASHBOARD} component={InfoDashboard} />
                    <Route path={ROUTES.BITACORA} component={Bitacora} />
                    <Route path={ROUTES.VIAJES} component={Viajes} />
                    <Route component={Page403} />
                  </Switch>
                </div>
                {/* <AppFooter /> */}
                <div className="layout-mask"></div>
              </div>
            );
          case ROLES.SEGUROS:
            return (
              <div className={wrapperClass}>
                <AppTopBar onToggleMenu={this.onToggleMenu} />
                <div className={sidebarClassName} onClick={this.onSidebarClick}>
                  <div className="layout-logo">
                    <img alt="VWM" src={logo} />
                  </div>
                  <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                  <div>
                    <p>Build: {process.env.REACT_APP_VERSION}</p>{' '}
                  </div>
                </div>
                <div className="layout-main">
                  {/* definir esta rutas igual en el archivo Routes.tsx */}
                  <Switch>
                    <Route path={ROUTES.DASHBOARD} component={InfoDashboard} />
                    <Route path={ROUTES.REV_EMERGENCIA} component={Emergencia} />
                    <Route path={ROUTES.VIAJES} component={Viajes} />
                    <Route component={Page403} />
                  </Switch>
                </div>
                {/* <AppFooter /> */}
                <div className="layout-mask"></div>
              </div>
            );
          case ROLES.ADMINNSO:
            return (
              <div className={wrapperClass}>
                <AppTopBar onToggleMenu={this.onToggleMenu} />
                <div className={sidebarClassName} onClick={this.onSidebarClick}>
                  <div className="layout-logo">
                    <img alt="VWM" src={logo} />
                  </div>
                  <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                  <div>
                    <p>Build: {process.env.REACT_APP_VERSION}</p>{' '}
                  </div>
                </div>
                <div className="layout-main">
                  {/* definir esta rutas igual en el archivo Routes.tsx */}
                  <Switch>
                    <Route path={ROUTES.DASHBOARD} component={InfoDashboard} />
                    <Route path={ROUTES.USUARIOS_ADMINDEALER} component={AdministradorDealer} />
                    <Route path={ROUTES.VIAJES} component={Viajes} />
                    <Route component={Page403} />
                  </Switch>
                </div>
                {/* <AppFooter /> */}
                <div className="layout-mask"></div>
              </div>
            );
          default:
            console.log(this.state.rol);
            return (
              <div className={wrapperClass}>
                <AppTopBar onToggleMenu={this.onToggleMenu} />

                <div className={sidebarClassName} onClick={this.onSidebarClick}>
                  <div className="layout-logo">
                    <img alt="VWM" src={logo} />
                  </div>
                  <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                  <div>
                    <p>Build: {process.env.REACT_APP_VERSION}</p>
                  </div>
                </div>

                <div className="layout-main">
                  {/* definir esta rutas igual en el archivo Routes.tsx */}
                  <Switch>
                    <Route path={ROUTES.DASHBOARD} component={InfoDashboard} />
                    {/* catalogos */}
                    <Route path={ROUTES.TRANSPORTISTAS} component={Transportistas} />
                    <Route path={ROUTES.CONCESIONARIOS} component={Concesionarios} />
                    <Route path={ROUTES.ENCURSO} component={ViajesEnCurso} />
                    <Route path={ROUTES.ENTREGADOS} component={ViajesEntregados} />
                    <Route component={Page403} />
                  </Switch>
                </div>
                {/* <AppFooter /> */}
                <div className="layout-mask"></div>
              </div>
            );
        }
    }
}

export default DashboardContainer;
